import React, { useState, useEffect } from "react"
import Modal from "react-modal"
import { ResponsiveTable, InfoModal } from "pharedata-responsive-components"

import { getAlertaImg } from '../../utils/tanquesSifoneados'
import { getLocaleStringNumber, getAproximate3FloatString } from "../../utils/utils.js"

import { customModalStyles } from "../../utils/styles"
import { showGreyBackground, hideGreyBackground, scrollTo } from "../../utils/windows.js"

import closeIcon from "../../../assets/img/cross-icon.svg"
import chevronRight from "../../../assets/img/chevron-right.svg"
import ojoIcon from "../../../assets/img/ojo.svg"

const styles = customModalStyles(20)
styles.content.padding = 0

const mobileColumns = [
  {"header": "Tanque", "key": "tanque", "showDetailArrow": false},
  {"header": "Material", "key": "material", "showDetailArrow": false},
  {"header": "Fluctuación<br />Diaria (Lts)", "key": "fluctuacion_diaria_lts", "showDetailArrow": false},
  {"header": "Alerta", "key": "alerta", "showDetailArrow": true}
]

const tabletColumns = [
  {"header": "Tanque", "key": "tanque", "showDetailArrow": false},
  {"header": "Material", "key": "material", "showDetailArrow": false},
  {"header": "Fluctuación Diaria (Lts)", "key": "fluctuacion_diaria_lts", "showDetailArrow": false},
  {"header": "Alerta", "key": "alerta", "showDetailArrow": true}
]

const data = [
  {key: "medicion_inicial", label: "Medición Inicial"},
  {key: "entradas", label: "Entradas"},
  {key: "salidas", label: "Salidas"},
  {key: "salida_acumulada_lts", label: "Salida Acumulada"},
  {key: "inventario_teorico", label: "Inventario Teórico"},
  {key: "medicion_fisica_proyectada", label: "Med Física Proyectada"},
  {key: "fluctuacion_diaria_lts", label: "Fluctuación Diaria Lts"},
  {key: "fluctuacion_acumulada_lts", label: "Fluctuación Acumulada Lts"},
  {key: "fluctuacion_porcentaje", label: "Porcentaje Fluctuación Acumulada", isPorcentaje: true},
  {key: "alerta", label: "Alerta", isAlerta: true}
]

const entradasSalidasColumns = [
  {"header": "Tanque", "key": "tanque", "showDetailArrow": false},
  {"header": "Material", "key": "material", "showDetailArrow": false},
  {"header": "Cantidad", "key": "total", "showDetailArrow": false}
]

export const ConfirmacionFluctuacionesMobile = ({ fluctuaciones, entradasSalidas }) => {
  const [viewFluctuacion, setViewFluctuacion] = useState()
  const [dataForTable, setDataForTable] = useState([])
  const [entradasSalidasData, setEntradasSalidasData] = useState()
  const [entradasSalidasTitle, setEntradasSalidasTitle] = useState("")

  useEffect(() => {
    if(fluctuaciones){
      const newDataArr = []
      fluctuaciones.forEach(function(fluctuacion, key){
        fluctuacion.tanques.forEach(function(tanque){
          tanque.inventario_teorico = fluctuacion.total.inventario_teorico
          tanque.material = fluctuacion.material
          tanque.alerta = getAlertaImg(tanque.alerta)
          newDataArr.push(tanque)

        })
      })
      setDataForTable(newDataArr)
    }
  }, [fluctuaciones])

  const closeModal = () => {
    setViewFluctuacion()
    setEntradasSalidasData()
    hideGreyBackground()
  }

  const selectFluctuacion = (fluctuacion) => {
    showGreyBackground()
    scrollTo(0, 0)
    setViewFluctuacion(fluctuacion)
  }

  const getValue = (row) => {
    const value = viewFluctuacion[row.key]

    if(row.isAlerta)
      return value
    else if(row.isPorcentaje)
      return getLocaleStringNumber(value) + "%"

    return getLocaleStringNumber(value)
  }

  const showEntradasSalidas = (type) => {
    if(type === "entradas")
      setEntradasSalidasTitle("Entradas")
    else
      setEntradasSalidasTitle("Salidas")

    const newData = []
    entradasSalidas.forEach(function(material){
      material.tanques.forEach(function(tanque){
        const total = getAproximate3FloatString(tanque[type].total)

        newData.push({
          tanque: tanque.tanque,
          material: material.material,
          total: total + " Lts."
        })
      })
    })
    showGreyBackground()
    setEntradasSalidasData(newData)
  }

  return (
    <div className="hide-desktop">
      <div className="responsive-actions responsive-actions-tablet">
        <button className="main-button hallow mobile-button tablet-button fluctuaciones-button" onClick={() => showEntradasSalidas("entradas")}>
          <div className="fluctuaciones-button--text"><img src={ojoIcon} />Entradas</div>
        </button>
        <button className="main-button hallow mobile-button tablet-button fluctuaciones-button" onClick={() => showEntradasSalidas("salidas")}>
          <div className="fluctuaciones-button--text fluctuaciones-button--text--salidas"><img src={ojoIcon} />Salidas</div>
        </button>
      </div>

      <div className="big-subtitle tablet-mobile-margin-top">
        Confirmación de Fluctuaciones
        <hr className="title-separator-line" />
      </div>
      <div className="show-only-mobile">
        <ResponsiveTable 
          columns={mobileColumns}
          data={dataForTable}
          showDetailFunction={selectFluctuacion}
        />
      </div>

      <div className="show-only-tablet">
        <ResponsiveTable 
          columns={tabletColumns}
          data={dataForTable}
          showDetailFunction={selectFluctuacion}
        />
      </div>

      {entradasSalidasData &&
        <InfoModal
          isOpen={true}
          closeModalFunction={closeModal}
          title={entradasSalidasTitle}
          columns={entradasSalidasColumns}
          data={entradasSalidasData}
        />
      }
      {viewFluctuacion &&
        <Modal isOpen={viewFluctuacion} onRequestClose={closeModal} style={styles} className="responsive-modal">
          <div className="mobile-filters__title responsive-filters">
            <h1 className="responsive-modal-title">Fluctuaciones</h1>
            <button className="mobile-filters__close-btn" onClick={closeModal}>
              <img src={closeIcon} alt="close modal" />
            </button>
          </div>
          <div className="mobile-filters__main-section">
            <table className="responsive-table separated-th-table">
              <thead>
                <tr>
                  <th>
                    <div className="th-data">Detalle</div>
                  </th>
                  <th>
                    <div className="th-data">Valor</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) =>
                  <tr key={`modal-row-${row.key}`}>
                    <td>
                      {row.label}
                    </td>
                    <td>
                      {getValue(row)}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

          </div>
          <div className="mobile-filters__footer">
            <button className="main-button" onClick={closeModal}>
              Cerrar
            </button>
          </div>
        </Modal>
      }
    </div>
  )
}
